/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Avatar } from '@mui/material';
import './PromotionsARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import PromotionRecentlyPromotedTile from '../../../components/PromotionRecentlyPromotedTile/PromotionRecentlyPromotedTile';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  promotions_data?: any;
  canAct: any;
  currentPromotionHistory: any;
  allActions?: any;
  handleSubmitAR_Request?: any;
  userId?: any;
}

const PromotionsARModalPresenter = ({
  isModalOpen,
  closeModal,
  currentPromotionHistory,
  trans,
  promotions_data,
  canAct,
  allActions,
  handleSubmitAR_Request,
  userId,
}: ModalProps) => {
  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: 'promotions',
        instanceId: promotions_data.instance_id,
        userId: userId,
        action: x ? x : '',
        context: {},
        model: 'emp_promotions',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="35vw">
      <ModalHeader
        modal={{ modal_title: trans('Promotions Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar_promotion">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: '10px' }}>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.darkBlue,
                      fontSize: '1em',
                      fontWeight: 'bold',
                    }}
                  >
                    {promotions_data?.first_name +
                      ' ' +
                      promotions_data?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.grey_colorDesignationAR,
                      fontSize: '0.825em',
                    }}
                  >
                    {promotions_data?.department_name} /{' '}
                    {promotions_data?.current_designation}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Promotion Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    <DateField
                      value={promotions_data?.promotion_date}
                      format={baseDateFormatting}
                    />
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Promotion From
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.primaryMain,
                      backgroundColor: '#F2E6F0',
                      padding: '5px',
                      borderRadius: '4px',
                    }}
                  >
                    {promotions_data?.prev_designation}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Promotion To
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: '#21D8A5',
                      backgroundColor: '#E8FBF6',
                      padding: '5px',
                      borderRadius: '4px',
                    }}
                  >
                    {promotions_data?.current_designation}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <i className="las la-eye" color={themes.primary} />
                  </Box>
                </Box>
              </Box>
              {/* <Box
                style={{
                  display: "flex",
                  marginTop: "0.5em",
                  width: "auto",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: themes.defaultScondary_blue,
                  }}
                >
                  Remarks
                </Typography>
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "12px",
                    color: themes.greyModalTitle,
                  }}
                >
                  Last 4 days I am not good
                </Typography>
              </Box> */}
              <Box style={{ marginTop: '1.5em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                {canAct && (
                  <TakeActionSplitBtn
                    title={'Take Action'}
                    menu={allActions}
                    onAction={(x: any) => handleTakeAction(x)}
                  />
                )}
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}

          <Grid item xs={6}>
            <Box className="bg_border_ar_promotion">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  Recently Promoted
                </Typography>
              </Box>

              {currentPromotionHistory &&
                currentPromotionHistory.map((d: any) => {
                  return (
                    <div key={d?.id}>
                      <PromotionRecentlyPromotedTile
                        promotion_to={d?.designation?.name}
                        emp_development={promotions_data?.department_name}
                        emp_name={
                          promotions_data?.first_name +
                          ' ' +
                          promotions_data?.last_name
                        }
                        emp_designation={d?.prev_designation?.name}
                      />
                    </div>
                  );
                })}
            </Box>
          </Grid>

          {/* {Horizontals Steps Label} */}
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default PromotionsARModalPresenter;
